import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

function Tab({ user, path, exact, title, onClick }) {
    return (
        <NavLink activeClassName="active" to={path} exact={exact} onClick={onClick}>
            {title}
        </NavLink>
    );
}

Tab.propTypes = {
    path: PropTypes.string.isRequired,
    exact: PropTypes.bool,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

export function NewsTab({ onClick }) {
    return <Tab path="/news" title="Новости" exact onClick={onClick} />;
}

NewsTab.propTypes = {
    onClick: PropTypes.func,
};

export function LawsTab({ onClick }) {
    return <Tab path="/laws" title="Право" exact onClick={onClick} />;
}

LawsTab.propTypes = {
    onClick: PropTypes.func,
};

export function DigestsTab({ onClick }) {
    return <Tab path={`/digests`} title="Дайджесты" onClick={onClick} />;
}

DigestsTab.propTypes = {
    onClick: PropTypes.func,
};

export function StatisticsTab({ onClick }) {
    return <Tab path={`/statistics`} title="Статистика" onClick={onClick} />;
}

StatisticsTab.propTypes = {
    onClick: PropTypes.func,
};

export function RiskCardTab({ onClick }) {
    return <Tab path={`/risk-card`} title="Отчетность" onClick={onClick} />;
}

RiskCardTab.propTypes = {
    onClick: PropTypes.func,
};

export function CalendarTab({ onClick }) {
    return <Tab path={`/calendar`} title="Календарь" onClick={onClick} />;
}

CalendarTab.propTypes = {
    onClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/navigation/nav/tabs/index.js